export const ApplePayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" fill="#F2F2F2" />
    <path
      d="M13.7744 6.24362C14.2587 5.63965 14.5874 4.82869 14.5007 3.99998C13.7917 4.03513 12.9266 4.46633 12.4257 5.07077C11.9759 5.58839 11.5779 6.43331 11.6817 7.22727C12.4775 7.2961 13.2726 6.83065 13.7744 6.24362Z"
      fill="black"
    />
    <path
      d="M14.4918 7.38225C13.336 7.31361 12.3534 8.03626 11.8014 8.03626C11.2492 8.03626 10.404 7.41684 9.48985 7.43354C8.30004 7.45096 7.19603 8.1217 6.59225 9.18849C5.35037 11.3226 6.26452 14.4882 7.47217 16.2263C8.05864 17.0862 8.76543 18.0331 9.69673 17.9991C10.5767 17.9646 10.9216 17.431 11.9911 17.431C13.0599 17.431 13.3706 17.9991 14.3021 17.9818C15.268 17.9646 15.8719 17.1215 16.4584 16.2608C17.1311 15.2805 17.4066 14.334 17.4239 14.2821C17.4066 14.2649 15.5613 13.5591 15.5442 11.4427C15.5267 9.67062 16.9929 8.82772 17.0619 8.77545C16.234 7.55451 14.9403 7.41684 14.4918 7.38225Z"
      fill="black"
    />
  </svg>
);
